import React, { useState } from "react";
import SuccessModal from "./SuccessModal"; // Adjust the import path if necessary
import Lottie from "lottie-react";
import animationData from "../Home/lottie/animation_lno0f30c.json";
import './ContactForm.css'
import AnimateOnScroll from 'react-animate-on-scroll'; // Import the animation component
import 'animate.css/animate.min.css'; // Import animate.css for animations
import {
  TextField,
  TextareaAutosize,
  Button,
  CircularProgress,
  Snackbar,
} from "@mui/material";

const ContactForm = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState({});
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const validateEmail = (email) => {
    const regex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/;
    return regex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};

    if (name.trim() === "") {
      newErrors.name = "Name is required";
    }

    if (!validateEmail(email)) {
      newErrors.email = "Email is required";
    }

    if (message.trim() === "") {
      newErrors.message = "Message is required";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      const response = await fetch("http://lankatech.wuaze.com/sendEmail", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ name, email, message }),
      });

      if (response.status === 200) {
        setShowSuccessModal(true); // Show the success modal
        setName("");
        setEmail("");
        setMessage("");
      } else {
        alert("Error sending email");
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact">
      <div className="container mt-5">
        <div className="row justify-content-center">
          <div
            className="col-md-6 "
            style={{ marginTop: 100, marginBottom: 100 }}
          >
            <AnimateOnScroll
              animateIn="animate__fadeIn" // Animation class from animate.css
              animateOnce={true} // Only animate once
            >
            <div className="card-body crd">
              <form onSubmit={handleSubmit} >
                <TextField
                  label="Name"
                  variant="outlined"
                  fullWidth
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                    setErrors({ ...errors, name: undefined });
                  }}
                  error={!!errors.name}
                  helperText={errors.name}
                />

                <TextField
                  label="Email"
                  variant="outlined"
                  fullWidth
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setErrors({ ...errors, email: undefined });
                  }}
                  error={!!errors.email}
                  helperText={errors.email}
                  style={{ marginTop: 10 }}
                />

                <TextField
                  id="outlined-textarea"
                  label="Message"
                  placeholder="Message"
                  rowsMin={4}
                  fullWidth
                  value={message}
                  multiline
                  variant="outlined" // Add this to specify the outlined variant
                  onChange={(e) => {
                    setMessage(e.target.value);
                    setErrors({ ...errors, message: undefined });
                  }}
                  error={!!errors.message}
                  style={{ marginTop: 10 }}
                />

                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  disabled={isSubmitting}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    marginTop: 60,
                  }}
                >
                  {isSubmitting ? <CircularProgress size={24} /> : "SEND"}
                </Button>
              </form>
            </div>
            </AnimateOnScroll>
          </div>
        </div>
      </div>
      <SuccessModal
        show={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
      />
    </section>
  );
};

export default ContactForm;
